import RemoteAudio from './remote';
import { Signaling } from './signaling';

const StreamAudio = async ({localStream,rtcPeer,socket}) => {
  if (!socket || !localStream) {throw new Error('StreamAudio missing socket or localStream');}
  RemoteAudio(rtcPeer);
  await Signaling(localStream,rtcPeer);
  return rtcPeer;
};

export default StreamAudio;